import { render, staticRenderFns } from "./PimsLogsComponent.vue?vue&type=template&id=4de701ee"
import script from "./PimsLogsComponent.js?vue&type=script&lang=js&external"
export * from "./PimsLogsComponent.js?vue&type=script&lang=js&external"
import style0 from "./PimsLogsComponent.vue?vue&type=style&index=0&id=4de701ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports